hns('I18n.publicLocales', {
  "af": {
    "language": "af",
    "beta": true,
    "defaultLocale": "af",
    "availableLocale": [
      "af"
    ]
  },
  "ar-eg": {
    "language": "ar-eg",
    "beta": true,
    "defaultLocale": "ar-eg",
    "availableLocale": [
      "ar-eg"
    ]
  },
  "bg": {
    "language": "bg",
    "beta": true,
    "defaultLocale": "bg",
    "availableLocale": [
      "bg"
    ]
  },
  "bn": {
    "language": "bn",
    "beta": true,
    "defaultLocale": "bn",
    "availableLocale": [
      "bn"
    ]
  },
  "ca-es": {
    "language": "ca-es",
    "beta": true,
    "defaultLocale": "ca-es",
    "availableLocale": [
      "ca-es"
    ]
  },
  "cs": {
    "language": "cs",
    "beta": true,
    "defaultLocale": "cs",
    "availableLocale": [
      "cs"
    ]
  },
  "da": {
    "language": "da",
    "beta": true,
    "defaultLocale": "da",
    "availableLocale": [
      "da"
    ]
  },
  "el": {
    "language": "el",
    "beta": true,
    "defaultLocale": "el",
    "availableLocale": [
      "el"
    ]
  },
  "en-gb": {
    "language": "en-gb",
    "beta": true,
    "defaultLocale": "en-gb",
    "availableLocale": [
      "en-gb"
    ]
  },
  "es-mx": {
    "language": "es-mx",
    "beta": true,
    "defaultLocale": "es-mx",
    "availableLocale": [
      "es-mx"
    ]
  },
  "fr-ca": {
    "language": "fr-ca",
    "beta": true,
    "defaultLocale": "fr-ca",
    "availableLocale": [
      "fr-ca"
    ]
  },
  "he-il": {
    "language": "he-il",
    "beta": true,
    "defaultLocale": "he-il",
    "availableLocale": [
      "he-il"
    ]
  },
  "hr": {
    "language": "hr",
    "beta": true,
    "defaultLocale": "hr",
    "availableLocale": [
      "hr"
    ]
  },
  "hu": {
    "language": "hu",
    "beta": true,
    "defaultLocale": "hu",
    "availableLocale": [
      "hu"
    ]
  },
  "id": {
    "language": "id",
    "beta": true,
    "defaultLocale": "id",
    "availableLocale": [
      "id"
    ]
  },
  "ko": {
    "language": "ko",
    "beta": true,
    "defaultLocale": "ko",
    "availableLocale": [
      "ko"
    ]
  },
  "lt": {
    "language": "lt",
    "beta": true,
    "defaultLocale": "lt",
    "availableLocale": [
      "lt"
    ]
  },
  "ms": {
    "language": "ms",
    "beta": true,
    "defaultLocale": "ms",
    "availableLocale": [
      "ms"
    ]
  },
  "no-no": {
    "language": "no-no",
    "beta": true,
    "defaultLocale": "no-no",
    "availableLocale": [
      "no-no"
    ]
  },
  "ro": {
    "language": "ro",
    "beta": true,
    "defaultLocale": "ro",
    "availableLocale": [
      "ro"
    ]
  },
  "ru": {
    "language": "ru",
    "beta": true,
    "defaultLocale": "ru",
    "availableLocale": [
      "ru"
    ]
  },
  "sk": {
    "language": "sk",
    "beta": true,
    "defaultLocale": "sk",
    "availableLocale": [
      "sk"
    ]
  },
  "sl": {
    "language": "sl",
    "beta": true,
    "defaultLocale": "sl",
    "availableLocale": [
      "sl"
    ]
  },
  "th": {
    "language": "th",
    "beta": true,
    "defaultLocale": "th",
    "availableLocale": [
      "th"
    ]
  },
  "tl": {
    "language": "tl",
    "beta": true,
    "defaultLocale": "tl",
    "availableLocale": [
      "tl"
    ]
  },
  "tr": {
    "language": "tr",
    "beta": true,
    "defaultLocale": "tr",
    "availableLocale": [
      "tr"
    ]
  },
  "uk": {
    "language": "uk",
    "beta": true,
    "defaultLocale": "uk",
    "availableLocale": [
      "uk"
    ]
  },
  "vi": {
    "language": "vi",
    "beta": true,
    "defaultLocale": "vi",
    "availableLocale": [
      "vi"
    ]
  },
  "zh-cn": {
    "language": "zh-cn",
    "beta": true,
    "defaultLocale": "zh-cn",
    "availableLocale": [
      "zh-cn"
    ]
  },
  "zh-hk": {
    "language": "zh-hk",
    "beta": true,
    "defaultLocale": "zh-hk",
    "availableLocale": [
      "zh-hk"
    ]
  },
  "zh-tw": {
    "language": "zh-tw",
    "beta": true,
    "defaultLocale": "zh-tw",
    "availableLocale": [
      "zh-tw"
    ]
  }
});